import { Injectable } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfirmModalComponent } from '../modals/confirm-modal/confirm-modal.component';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Injectable()
/**
 * Custom modal service
 * Service for modals
 */
export class CustomModalService {
    /**
     * Local references
     */
    private modalRefs: BsModalRef[] = [];
    private modalCount = 0;

    constructor(private bsModalService: BsModalService, private location: PlatformLocation) {
        // closes modal when back button is clicked
        location.onPopState(() => {
            this.modalRefs.forEach((modal: BsModalRef) => {
                if (modal.content && !modal.content.preventHideOnBackButton) {
                    modal.hide();
                }
            });
        });

        /**
         * handle manual and browser back button case instead of prev implementation row 92
         */
        this.bsModalService.onHide.subscribe(() => this.modalCount--);
    }

    /**
     * Modal initialization
     * @param componentName component name (not necessary parameter)
     * @param data input data (not necessary parameter)
     * @param className class name (not necessary parameter)
     */
    initModal(
        component: any = ConfirmModalComponent,
        data?: object,
        className: string = 'modal-confirm',
        config?: ModalOptions
    ): Observable<any> {
        const subject = new Subject<boolean>();
        const modal = this.bsModalService.show(component, {
            backdrop: 'static',
            keyboard: false,
            class: `${className} modal-dialog-centered`,
            initialState: data,
        });

        (modal.content as any).subject = subject;
        this.modalRefs.push(modal);
        this.modalCount++;

        return subject.asObservable().pipe(
            tap(() => {
                modal.hide();
                this.modalCount--;
            })
        );
    }

    closeAllModals(): void {
        this.modalRefs.forEach((modal: BsModalRef) => modal.hide());
    }
    closeModal(component: any): void {
        const modalRef = this.modalRefs.find(modal => modal.content instanceof component);
        if (modalRef) {
            modalRef.hide();
            this.modalRefs = this.modalRefs.filter(modal => modal !== modalRef);
            this.modalCount--;
        }
    }
    
}
